'use strict';

(function (angular) {
  var standingOrderPriceStatusCache = null;

  angular.module('ibf').controller('countryStandingOrderPriceStatusCtrl', ['alertify', '$q', 'commonSrv', 'environment', countryStandingOrderPriceStatusCtrl]);

  function countryStandingOrderPriceStatusCtrl(alertify, $q, commonSrv, environment) {
    var obj = this;
    var common = commonSrv;
    var PAGE_SIZE = 8;
    var STATUS_ALL = 'all';
    var STATUS_RED = 'red';
    var STATUS_YELLOW = 'yellow';
    var STATUS_GREEN = 'green';

    obj.isLoading = false;
    obj.hasLoaded = false;
    obj.filter = STATUS_ALL;
    obj.searchText = '';
    obj.pageSize = PAGE_SIZE;
    obj.sections = [];
    obj.summary = {};
    obj.filteredTotal = 0;
    obj.totalGrowers = 0;
    obj.lastLoadedAt = null;
    obj.allSection = createSection(STATUS_ALL, 'All growers', 'Alphabetical list of all growers', 'all');

    function init() {
      buildSections();
      loadData();
    }

    function loadVisibleGrowers() {
      var userData = common.getUserData() || {};
      var countries = userData.countries ? userData.countries.map(function (item) {
        return item.country;
      }) : [];
      var showAll = ['BOOKKEEPING', 'LOGISTICS_SUPPORT', 'ADMIN'].includes(userData.ibf_role);

      return common.method.run({
        key: environment.cloudscript.loadDependencies,
        params: {
          includes: ['grower']
        }
      }).then(function (res) {
        var growers = [];

        if (res && res.success && res.results && res.results.grower) {
          growers = showAll ? res.results.grower.filter(function (item) {
            return item.active;
          }) : countries.length > 0 ? res.results.grower.filter(function (item) {
            return item.active && countries.includes(item.country);
          }) : [];
        }

        return growers.sort(function (a, b) {
          return a.company_name.localeCompare(b.company_name);
        });
      });
    }

    function buildSections() {
      obj.sections = [createSection(STATUS_RED, 'Needs attention', 'Less than 20 active standing order prices', 'red'), createSection(STATUS_YELLOW, 'Watch list', 'Between 20 and 30 active standing order prices', 'yellow'), createSection(STATUS_GREEN, 'Healthy coverage', 'More than 30 active standing order prices', 'green')];
      updateSummary();
    }

    function createSection(key, title, description, tone) {
      return {
        key: key,
        title: title,
        description: description,
        tone: tone,
        items: [],
        filteredItems: [],
        currentPage: 1,
        totalItems: 0,
        pageItems: [],
        visible: true
      };
    }

    function classifyCount(count) {
      if (count < 20) {
        return STATUS_RED;
      }

      if (count <= 30) {
        return STATUS_YELLOW;
      }

      return STATUS_GREEN;
    }

    function normalizeText(value) {
      return (value || '').toString().trim().toLowerCase();
    }

    function matchesSearch(item) {
      if (!obj.searchText) {
        return true;
      }

      return normalizeText(item.company_name).indexOf(normalizeText(obj.searchText)) !== -1;
    }

    function buildStatusMeta(count) {
      var status = classifyCount(count);
      var meta = {
        key: status,
        label: 'Green',
        cardClass: 'standing-order-price-status__table-row--green'
      };

      if (status === STATUS_RED) {
        meta.label = 'Red';
        meta.cardClass = 'standing-order-price-status__table-row--red';
      } else if (status === STATUS_YELLOW) {
        meta.label = 'Yellow';
        meta.cardClass = 'standing-order-price-status__table-row--yellow';
      }

      return meta;
    }

    function mapGrowersWithCounts(growers, records) {
      var countsByGrower = {};
      var items = [];

      angular.forEach(records || [], function (item) {
        if (!item || !item.grower) {
          return;
        }

        countsByGrower[item.grower] = (countsByGrower[item.grower] || 0) + 1;
      });

      angular.forEach(growers || [], function (grower) {
        var total = countsByGrower[grower._KEY] || 0;
        var statusMeta = buildStatusMeta(total);

        items.push({
          growerKey: grower._KEY,
          company_name: grower.company_name,
          totalActivePrices: total,
          status: statusMeta.key,
          statusLabel: statusMeta.label,
          statusRowClass: statusMeta.cardClass
        });
      });

      return items.sort(function (a, b) {
        if (b.totalActivePrices !== a.totalActivePrices) {
          return b.totalActivePrices - a.totalActivePrices;
        }

        return a.company_name.localeCompare(b.company_name);
      });
    }

    function chunkArray(items, size) {
      var chunked = [];
      var index = 0;

      while (index < items.length) {
        chunked.push(items.slice(index, index + size));
        index += size;
      }

      return chunked;
    }

    function loadChunkedPriceRecords(growerKeys) {
      var chunks = chunkArray(growerKeys || [], 150);
      var requests = chunks.map(function (keys) {
        var query = common.sbx.with('so_grower_prices').andWhereIn('grower', keys).andWhereIsEqual('masterlist.active', true).compile();

        return $q(function (resolve) {
          common.loadAllPages(query, function (data) {
            resolve(data && data.results ? data.results : []);
          });
        });
      });

      return $q.all(requests).then(function (results) {
        return [].concat.apply([], results);
      });
    }

    function updateSummary() {
      var red = getSectionByKey(STATUS_RED);
      var yellow = getSectionByKey(STATUS_YELLOW);
      var green = getSectionByKey(STATUS_GREEN);

      obj.summary = {
        total: obj.totalGrowers || 0,
        red: red ? red.items.length : 0,
        yellow: yellow ? yellow.items.length : 0,
        green: green ? green.items.length : 0
      };
    }

    function getSectionByKey(key) {
      return (obj.sections || []).find(function (section) {
        return section.key === key;
      });
    }

    function assignItemsToSections(items) {
      obj.allSection.items = angular.copy(items).sort(function (a, b) {
        return a.company_name.localeCompare(b.company_name);
      });

      angular.forEach(obj.sections, function (section) {
        section.items = items.filter(function (item) {
          return item.status === section.key;
        });
      });

      obj.totalGrowers = items.length;
      updateSummary();
      applyFilter();
    }

    function applyCachedData(cache) {
      assignItemsToSections(angular.copy(cache.items || []));
      obj.lastLoadedAt = cache.lastLoadedAt || null;
      obj.hasLoaded = true;
      obj.isLoading = false;
    }

    function updateSectionPage(section) {
      var initIndex = (section.currentPage - 1) * obj.pageSize;
      var endIndex = initIndex + obj.pageSize;

      section.pageItems = section.filteredItems.slice(initIndex, endIndex);
    }

    function updateVisibleSections() {
      obj.filteredTotal = 0;

      obj.allSection.visible = obj.filter === STATUS_ALL;
      obj.allSection.filteredItems = obj.allSection.visible ? angular.copy(obj.allSection.items).filter(matchesSearch) : [];
      obj.allSection.totalItems = obj.allSection.filteredItems.length;
      obj.allSection.currentPage = 1;
      updateSectionPage(obj.allSection);

      angular.forEach(obj.sections, function (section) {
        section.visible = obj.filter !== STATUS_ALL && obj.filter === section.key;
        section.filteredItems = section.visible ? angular.copy(section.items).filter(matchesSearch) : [];
        section.totalItems = section.filteredItems.length;
        section.currentPage = 1;
        updateSectionPage(section);
      });

      obj.filteredTotal = obj.filter === STATUS_ALL ? obj.allSection.totalItems : obj.sections.reduce(function (total, section) {
        return total + section.totalItems;
      }, 0);
    }

    function loadData(forceReload) {
      if (!forceReload && standingOrderPriceStatusCache) {
        applyCachedData(standingOrderPriceStatusCache);
        return;
      }

      obj.isLoading = true;

      loadVisibleGrowers().then(function (growers) {
        var growerKeys = growers.map(function (grower) {
          return grower._KEY;
        });

        if (!growerKeys.length) {
          standingOrderPriceStatusCache = {
            items: [],
            lastLoadedAt: new Date()
          };
          applyCachedData(standingOrderPriceStatusCache);
          return;
        }

        loadChunkedPriceRecords(growerKeys).then(function (records) {
          standingOrderPriceStatusCache = {
            items: mapGrowersWithCounts(growers, records),
            lastLoadedAt: new Date()
          };
          applyCachedData(standingOrderPriceStatusCache);
        }).catch(function () {
          obj.isLoading = false;
          alertify.error('Failed to load standing order prices');
        });
      }).catch(function () {
        obj.isLoading = false;
        alertify.error('Failed to load growers');
      });
    }

    function applyFilter() {
      updateVisibleSections();
    }

    obj.setFilter = function (filter) {
      obj.filter = filter || STATUS_ALL;
      applyFilter();
    };

    obj.onSearchChange = function () {
      applyFilter();
    };

    obj.clearSearch = function () {
      obj.searchText = '';
      applyFilter();
    };

    obj.getSectionVisibleRangeLabel = function (section) {
      if (!section || !section.totalItems) {
        return '0 growers';
      }

      var start = (section.currentPage - 1) * obj.pageSize + 1;
      var end = Math.min(section.currentPage * obj.pageSize, section.totalItems);

      return start + ' - ' + end + ' of ' + section.totalItems + ' growers';
    };

    obj.getTableEmptyMessage = function () {
      if (obj.filter === STATUS_RED) {
        return 'No growers are currently below 20 active standing order prices.';
      }

      if (obj.filter === STATUS_YELLOW) {
        return 'No growers are currently between 20 and 30 active standing order prices.';
      }

      if (obj.filter === STATUS_GREEN) {
        return 'No growers are currently above 30 active standing order prices.';
      }

      return 'No growers are available for this report.';
    };

    obj.onSectionPageChange = function (section) {
      updateSectionPage(section);
    };

    obj.reload = function () {
      standingOrderPriceStatusCache = null;
      loadData(true);
    };

    init();
  }
})(angular);
//# sourceMappingURL=countryStandingOrderPriceStatusCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('floristIBuyFlwCartCtrl', ['$scope', 'alertify', '$state', '$filter', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', 'paymentSrv', 'shippingSrv', floristIBuyFlwCartCtrl]).controller('floristIBuyFlwCartItemsCtrl', ['$scope', 'alertify', '$state', '$filter', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', '$uibModalInstance', 'data', floristIBuyFlwCartItemsCtrl]).controller('floristIBuyFlwBoxCodeCtrl', ['$scope', 'alertify', '$state', '$filter', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', '$uibModalInstance', 'data', floristIBuyFlwBoxCodeCtrl]);

  function floristIBuyFlwCartCtrl($scope, alertify, $state, $filter, $stateParams, commonSrv, sessionSrv, floristSrv, paymentSrv, shippingSrv) {

    var obj = this,
        common = commonSrv,
        florist = floristSrv;
    var countryMap = {};
    obj.total_bunches = 0;
    obj.total_prices = 0;
    obj.notReady = true;
    obj.callFinish = [false, false];
    obj.total_gift = 0;
    obj.offer = common.offer_per;

    obj.isCurrent = function (name) {
      return $state.is('florist.ibuyflowers.' + name);
    };

    function init() {
      obj.userData = common.getUserData();
      obj.loadCountries();
      initLoad();
      obj.listPaymentOptions();
    }

    function initLoad() {
      async.waterfall([function (cb) {
        obj.loadAddres(function () {
          cb(null);
        });
      }, function (cb) {
        obj.loadList(function () {
          cb(null);
        });
      }], function (err) {
        obj.notReady = false;
      });
    }

    obj.addPayment = function () {
      var modalInstance = paymentSrv.addPaymentMethodModal({});

      modalInstance.result.then(function (result) {

        obj.listPaymentOptions();
      }, function (msg) {
        obj.listPaymentOptions();
        //$state.reload();
      });
    };

    obj.getImage = function (item) {
      var country = countryMap[item.grower.country];
      if (country) {
        return common.actual_base_url + '/flags/' + country.country_iso + '_flag.png';
      };
      return null;
    };

    obj.changeCard = function (card) {
      obj.card = card;
    };

    obj.listPaymentOptions = function () {
      paymentSrv.listPaymentMethods(function (methods) {

        obj.paymentMethods = methods.sort(function (a, b) {
          return new Date(b.created) - new Date(a.created);
        });

        if (obj.paymentMethods.length) {

          var card = obj.paymentMethods[0];

          angular.forEach(obj.paymentMethods, function (item) {

            if (item.is_default) {
              card = item;
            }
          });

          obj.card = card;
        }
      }, function (error) {
        alertify.error(error);
      });
    };

    obj.loadAddres = function (cb) {
      florist.getCompanyInfo('customer', function (data) {
        obj.info = data.results[0];
        if (cb) {
          cb();
        }
      }, function (err) {
        alertify.error(err);
        if (cb) {
          cb();
        }
      });
    };

    obj.verifyFinish = function () {
      var ready = true;
      for (var i = 0; i < obj.callFinish.length; i++) {
        if (!obj.callFinish[i]) {
          ready = false;
          break;
        }
      };

      return ready;
    };

    obj.loadCountries = function () {
      florist.getCountriesList(function (data) {
        angular.forEach(data.results, function (item) {
          countryMap[item._KEY] = item;
        });
        obj.countries = data.results;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.loadList = function (callFinish) {
      obj.total_bunches = 0;
      obj.total_prices = 0;
      obj.subtotal = 0;
      obj.total_extra_freight_cost = 0;
      var mapOrder = {};
      var aux = [];
      florist.getShoppingCart(function (res) {
        obj.total_boxes = res.length;
        var res = $filter('orderBy')(res, 'consecutive');
        async.waterfall([function (cb) {
          // if (!common.userData.is_gift) {
          //   return cb(null);
          // }

          common.applyGift(res, function (response) {
            obj.total_gift = response.total_gift;
            cb(null);
          });
        }, function (cb) {
          var total_prices = 0;
          var subtotal = 0;
          var extra_freight_cost = 0;
          angular.forEach(res, function (item, value) {
            obj.total_bunches = obj.total_bunches + parseInt(item.total_items);
            total_prices = total_prices + parseFloat(item.price);
            subtotal = subtotal + parseFloat(item.subtotal);
            extra_freight_cost = extra_freight_cost + parseFloat(item.extra_freight_cost);
            var day = item.eta_date.toISOString();
            if (mapOrder[day] == null) {
              mapOrder[day] = aux.length;
              aux.push({
                eta_date: day,
                cartboxes: []
              });
            };

            aux[mapOrder[day]].cartboxes.push(item);
          });

          obj.total_prices = total_prices - obj.total_gift;
          obj.total_extra_freight_cost = extra_freight_cost;
          obj.subtotal = subtotal;
          obj.cartboxes = res;
          obj.list = aux;
          cb(null);
        }], function (err) {
          if (err) {
            return;
          }
          if (callFinish) {
            callFinish();
          }
        });
      }, function () {
        if (callFinish) {
          callFinish();
        }
      });
    };

    obj.calculateTotals = function (list) {
      angular.forEach(list, function (item) {
        obj.total_bunches = obj.total_bunches + parseInt(item.total_items);
        obj.total_prices = obj.total_prices + parseFloat(item.price);
      });
    };

    obj.showDetail = function (cartbox) {
      var modalInstance = florist.showDetailCartBox({
        cartbox: cartbox
      });
    };

    obj.isDeleted = function () {
      return true;
    };

    obj.addBoxCode = function (cartbox) {
      var modalInstance = florist.addBoxCode({
        cartbox: cartbox
      });

      modalInstance.result.then(function () {
        obj.loadList();
      });
    };

    obj.deleteBox = function (cartbox) {
      var dialog = common.showDialogProgress({ msj: 'Deleting..' });
      florist.deleteBox(cartbox, function () {
        dialog.close();
        //window.Intercom("trackEvent", "on_cartbox_deleted");
        obj.loadList();
      }, function (err) {
        dialog.close();
        alertify.error(err);
      });
    };

    obj.checkoutPurchase = function () {
      if (obj.notReady) {
        return alertify.error('shopping cart is not ready');
      };

      if (!obj.card) {
        return alertify.alert('Please add first a payment method before you can checkout.');
      };
      var cartboxesToDelete = [];
      angular.forEach(obj.cartboxes, function (cartbox) {
        if (!shippingSrv.checkCartBoxShipDay(cartbox)) {
          cartboxesToDelete.push(cartbox);
        }
      });

      if (cartboxesToDelete.length) {
        return common.confirmModal({
          title: 'Information',
          msj: 'Some of the items in your shopping cart are outdated and they will be removed. \nPlease make sure you checkout at least 72 hours before arriving to your doorstep to avoid this issue.',
          saveText: 'OK',
          alignRight: true,
          hideCancel: true,
          size: 'md'
        }, function () {
          obj.loadList();
        });
      }

      var shoppingcart = {
        info: obj.info,
        list: obj.cartboxes,
        total: obj.total_prices,
        subtotal: obj.total_prices,
        card: obj.card
      };

      var dialog = common.showDialogProgress({ msj: 'We are processing your order.' });

      florist.checkoutPurchase(shoppingcart, function (key) {
        var meta = {
          user_id: common.getUserData().data.id,
          card: shoppingcart.card.card_brand,
          customer: shoppingcart.info.company_name,
          total_price: shoppingcart.total
        };
        common.registerEvent(meta, 'order_checkout');
        //window.Intercom("trackEvent", "order_checkout");
        alertify.success('Your order has been placed.');
        $state.go('florist.purchaseorders.detail', { purchaseId: key });
        dialog.close();
        obj.loadList();
      }, function (err) {
        alertify.error(err);
      });
    };

    init();
  }

  function floristIBuyFlwCartItemsCtrl($scope, alertify, $state, $filter, $stateParams, commonSrv, sessionSrv, floristSrv, $uibModalInstance, data) {

    var modal = this,
        common = commonSrv,
        florist = floristSrv;
    modal.cartbox = data.cartbox;

    function init() {
      modal.loadList();
    }

    modal.loadList = function () {
      florist.getCartBoxItems(modal.cartbox._KEY, function (res) {
        modal.list = res.results;
      }, function (err) {
        alertify.error(err);
      });
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    init();
  }

  function floristIBuyFlwBoxCodeCtrl($scope, alertify, $state, $filter, $stateParams, commonSrv, sessionSrv, floristSrv, $uibModalInstance, data) {

    var modal = this,
        common = commonSrv,
        florist = floristSrv;

    function init() {
      modal.cartbox = data.cartbox;
    }

    modal.save = function () {

      if (modal.formBoxCode.$invalid) {
        return;
      };
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    init();
  }
})(angular);
//# sourceMappingURL=floristIBuyFlwCartCtrl.js.map
